<template>
    <CardPage :section="section" :page="1" :audio="audio">
        <ResponsiveImage :src="sticker.image" :alt="title" flex="xs2"></ResponsiveImage>
        <p class="headline text-xs-center">{{ title }}</p>
        <slot></slot>
    </CardPage>
</template>

<script>
export default {
    props: {
        section: {
            type: Number,
            required: true
        },
        audio: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        title() {
            return this.$store.get(`section${this.section}/title`);
        },
        sticker() {
            return this.$store.get(`section${this.section}/sticker`);
        }
    }
};
</script>
